import { render, staticRenderFns } from "./mainTree.vue?vue&type=template&id=610d5f3a&scoped=true&"
import script from "./mainTree.vue?vue&type=script&lang=js&"
export * from "./mainTree.vue?vue&type=script&lang=js&"
import style0 from "./mainTree.vue?vue&type=style&index=0&id=610d5f3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d5f3a",
  null
  
)

export default component.exports